import * as storage from '../utils/storage';

export function GetLanguage() {
    return storage.getLanguage();
}

export function IsEnglish() {
    return GetLanguage()?.toLowerCase() === 'en';
}